import html2pdf from 'html2pdf.js';
import { IDropdownDataOptions } from 'src/app/model/common.model';
import { FileAttachmentTagStatuses } from 'src/app/shared/enums/file-attachment-tag.enum';
import { EmailPayload } from '../../service/email.model';


/**
 * @deprecated This class is deprecated and will be removed in future versions.
 * Please use appropriate services, like @app/shared/services/timezone/timezone-shared.service.ts for handling timezones instead.
 */
export class Constant {
  // TODO: Need To remove any type from this file.
  static templist = [];
  static msgPageOpen = false;
  static selectedMenu: string;
  static selectedTimeZone: string = 'US/Mountain';
  static selectedTimeZoneShortValue: string = 'MST(UTC -7)';
  static selectedOffsetTime: string = '-420';
  static selectedGMTValue: string;

  static sortByCol(name: string) {

    if (this.templist.length > 0) {
      if (this.templist.indexOf(name) !== -1) {
        this.templist.pop();
      } else {

        this.templist.push(name);
      }
    } else {
      this.templist.push(name);
    }

    let order = this.templist.join();
    return order;
  }

  static showPaginationMessage(totalData, pageNumber, selectedPage) {
    if (pageNumber == undefined)
      pageNumber = 1;
    let showString = "Showing " + (pageNumber == 1 ? pageNumber : (((pageNumber - 1) * selectedPage) + 1)) + " to " + ((totalData > (selectedPage * pageNumber)) ? (selectedPage * pageNumber) : totalData) + " of " + totalData + " entries";
    return showString;
  }
  static uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
  static errorEmail: EmailPayload = {
    'receiverList': [
      'neeraj.kushwaha@interbizconsulting.com',
      'suraj.yadav@interbizconsulting.com',
      'anurag.pandey@interbizconsulting.com',
      'meera.sahu@interbizconsulting.com',
      'manikant.mahto@interbizconsulting.com'
    ],
    'subject': 'API Error Message',
    'message': ''
  };
  static isSideMenuOpen = true;
  static download(id) {
    const option = {
      filename: this.selectedMenu + ".pdf",
      image: { type: 'jpeg', quality: 1 },
      pagebreak: { avoid: 'tr' },
      html2canvas: { scale: 5, allowTaint: true, useCORS: true, foreignObjectRendering: false },
      jsPDF: { unit: 'em', format: 'a3', orientation: 'landscape', precision: 100, compress: true, floatPrecision: "smart" }
    };
    const element: Element = document.getElementById(id);
    html2pdf().from(element).set(option).save();
  }
}

export const AdminEmailRegEx = {
  trinityDomainRegEx: new RegExp("^[A-Za-z0-9._%+-]+@trinityairmedical\.com$"),
  srtaDomainRegEx: new RegExp("^[A-Za-z0-9._%+-]+@srta\.com$")
};

/**
 * @deprecated - please use UserRoleEnum
 *
 * @see import { UserRoleEnum } from '@enums/user-role.enum';
 */
export const RoleName = {  ExecutiveAdmin: 'Executive Admin',
  Coordinator: 'Coordinator',
  CustomerAdmin: 'Customer Admin',
  CustomerCoordinator: 'Customer Coordinator',
  Accounting: 'Accounting',
  Driver: 'Driver',
  Management: 'Management',
  VendorAdmin: 'Vendor Admin',
  VendorCoordinator: 'Vendor Coordinator',
  VendorDriver: 'Vendor Driver',
  InternalReadOnly: 'Internal Read Only'
};

export const PageName = {
  ExecutiveDashboard: 'Executive Dashboard',
  DriverDashboard: 'Driver Dashboard',
  CustomerDashboard: 'Customer Dashboard',
  VendorDashboard: 'Vendor Dashboard',
  FinanceDashbaord: 'Finance Dashboard',
  ServiceRequest: 'Service Request',
  ManageVendor: 'Manage Vendor',
  VendorDetails: 'Vendor Details',
  ManageCustomer: 'Manage Customer',
  CustomerDetails: 'Customer Details',
  ManageMember: 'Manage Member',
  ManageVehicle: 'Manage Vehicle',
  ManageData: 'Manage Data',
  Report: 'Report',
  Time: 'Time',
  ManageRole: 'Manage Role',
  Profile: 'Profile'
};

export const EnabledCountryCodes = ["US", "PR", "CA", "IN"];  //TODO Remove India's Country code after testing
export const AddressType: string[] = ['Residential', 'Hospital', 'Other'];
export const AddressFields: string[] = ["address_component", "adr_address", "business_status", "formatted_address"]
export const ZipCodePattern: string = "/^[1-9a-zA-Z]{3,5}$/;"; //check three or 5 alphanumeric values

export const LegDetailsFilterOption = {
  Active: 'Active',
  AboutToStart: 'AboutToStart',
  Completed: 'Completed'
};

export const RequestFor = {
  LegAssignmentRequests: 'Leg Assignment Requests',
  ActiveRequests: 'Active Requests'
};

export const Header = {
  pendingRequests: 'Pending Requests',
  activeRequests: 'Active Requests',
  completedRequests: 'Completed Requests'
};

export const Organ = {
  heart: 'Heart',
  lung: 'Lung',
  liver: 'Liver',
  kidney: 'Kidney',
  pancreas: 'Pancreas',
  intestine: 'Intestine'
};

export const RegionOptions: IDropdownDataOptions[] = [
  { id: 1, name: 'East', isDisabled: false },
  { id: 2, name: 'West', isDisabled: false },
  { id: 3, name: 'Central', isDisabled: false },
  { id: 4, name: 'LifeSource', isDisabled: true },
];

export const GroundResponseTimeOptions: IDropdownDataOptions[] = [
  { id: 1, name: '60', value: 60, isDisabled: false },
  { id: 2, name: '90', value: 90, isDisabled: false },
  { id: 3, name: '120', value: 120, isDisabled: false },
  { id: 4, name: '180', value: 180, isDisabled: false },
];

export const RegionNames = {
  East: 'East',
  West: 'West',
  Central: 'Central',
  LifeSource: 'LifeSource',
};

export const VehicleTypeList = {
  allVehicle: 'All Vehicles',
  normalVehicle: 'Normal Vehicles',
  sirenVehicle: 'Siren Vehicles',
};

export const LegDetailStatus = {
  notStarted: 'Not Started',
  enroute: 'Enroute',
  onScene: 'On-Scene',
  onBoard: 'On-board',
  pickedUp: 'Picked up',
  wheelsUp: 'Wheels Up',
  landed: 'Landed',
  droppedOff: 'Dropped Off',
  driverDone: 'Driver Done',
  jobDone: 'Job Done',
  repositioning: 'Repositioning',
  inPosition: 'In Position',
  onStandby: 'On Standby'
};

export const AssignmentRequestStatus = {
  accepted: 'Accepted',
  rejected: 'Rejected',
  requested: 'Requested',
};

export enum TransportType {
  GROUND = 'Ground',
  AIR = 'Air',
  MISCELLANEOUS = 'Miscellaneous'
}

export const VehicleCategoryType = {
  AIRCRAFT: 'Aircraft',
  VEHICLE: 'Vehicle'
};

export const RateType = {
  FLAT: 'Flat',
  BLOCK: 'Block',
  MARKUP_FLAT: 'Mark Up Flat',
  MARKUP_PERCENTAGE: 'Mark Up Percentage'
};

export enum TransportationFileUploadType {
  SafetyCredentials = 'SafetyCredentials',
  Insurance = 'Insurance',
  Registration = 'Registration'
}

export const ServiceTypeNames = {
  equipment: 'Equipment',
  internal: 'Internal',
  nextFlightOut: 'Next Flight Out',
  organ: 'Organ',
  specimen: 'Specimen',
  team: 'Team',
  handCarry: 'Hand Carry'
};

export const ServiceSubType = {
  heart: 'Heart',
  intestines: 'Intestines',
  kidneyOnPumpLeft: 'Kidney on Pump Left',
  kidneyOnPumpRight: 'Kidney On Pump Right',
  kidneyL: 'Kidney L',
  kidneyLOnPump: 'Kidney L On Pump',
  kidneyR: 'Kidney R',
  kidneyROnPump: 'Kidney R On Pump',
  leftKidney: 'Left Kidney',
  leftLung: 'Left Lung',
  lKidney: 'L Kidney',
  lLung: 'L Lung',
  lLungs: 'L Lungs',
  liver: 'Liver',
  lungL: 'Lung L',
  lungR: 'Lung R',
  lungs: 'Lungs',
  pancreas: 'Pancreas',
  rightKidney: 'Right Kidney',
  rightLung: 'Right Lung',
  rKidney: 'R Kidney',
  rLung: 'R Lung',
  tissue: 'Tissue',
  tissueSample: 'Tissue Sample',
  coordinator: 'Coordinator'
};

export const NumberOfEntriesToShow = [10, 25, 50, 100];
export const NumberOfEntries = [5, 10, 15, 20];
export const NumberOfEntry = [5, 10, 15, 20, 50, 100];
export const DateFilters = ['Today', 'Last 24 Hours', 'Last 7 Days', 'Last 30 Days', 'Last 3 Months', 'Last 1 Year'];
export const DefaultGUID = '00000000-0000-0000-0000-000000000000';

export const Months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const DefaultLatLngCoordinates = {
  latitude: 33.533482,
  longitude: -112.107254
};

export const DefaultTextMessageUTCDate = '0001-01-01T00:00:00';

export const ChatType = {
  individual: 'Individual',
  group: 'Group'
};

export const SRGroupType = {
  internal: 'Internal',
  customer: 'Customer',
  vendor: 'Vendor',
  custom: 'Custom'
};

export const fileType = {
  jpg: 'image/jpg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif'
};

export const entityTableName = {
  chatGroupMessage: 'ChatGroupMessage'
};

export const attachmentOf = {
  profilePic: 'profilePic',
  messageAttachment: 'messageAttachment'
};

export const TransportTypes = [
  { id: "1", name: "Air" },
  { id: "2", name: "Ground" },
];

export const PriorityList = [
  { id: 1, name: "1" },
  { id: 2, name: "2" },
  { id: 3, name: "3" }
];

export const DaysFilters = {
  today: 'Today',
  last24Hours: 'Last 24 Hours',
  sevenDays: '7 Days',
  thirtyDays: '30 Days',
  oneYear: '1 Year'
};

export const InvoiceStatus = {
  InProgress: 'In Progress',
  Success: 'Success',
  Failed: 'Failed',
};

export const CancellationReasons = {
  caseCancelled: 'Case Cancelled',
  cost: 'Cost',
  donorDidNotProgress: 'Donor did not progress',
  duplicateJob: 'Duplicate Job',
  internalTrip: 'Internal trip',
  organDeclined: 'Organ Declined',
  otherDetailsInNotes: 'Other - Details in notes',
  reschedulingOR: 'Rescheduling OR',
  unableToMeetTiming: 'Unable to meet timing',
  utilizingDifferentProvider: 'Utilizing different provider'
};

export const GenderType = {
  male: 'Male',
  female: 'Female',
  anotherGender: 'Another Gender'
};

export const NoteCategories = {
  initialSummary: 'Initial Summary',
  d2D: 'D2D',
  pickUpInfo: 'Pick Up Info',
  dropOffInfo: 'Drop off info',
  aircraft: 'Aircraft',
  ground: 'Ground',
  catering: 'Catering',
  tripChanges: 'Trip Changes',
  oRUpdates: 'OR Updates',
  delay: 'Delay',
  finance: 'Finance',
  mOCApproval: 'MOC Approval',
};

export const donorType = {
  DBD: {
    name: 'DBD',
    title: 'Donation After Brain Death',
  },
  DCD: {
    name: 'DCD',
    title: 'Donation After Circulatory Death',
  }
};

export const PickupType = {
  Future: 'Future',
  Immediate: 'Immediate'
};

export const FileAttachmentTagStatusClassMap: { [key: string]: string } = {
  [FileAttachmentTagStatuses.flightRequestForm]: 'landedCompleted-class',
  [FileAttachmentTagStatuses.aviationSpecialistApproval]: 'enroute-class',
  [FileAttachmentTagStatuses.airCharterQuote]: 'on-standby-status-class',
  [FileAttachmentTagStatuses.airCharterItinerary]: 'reposition-status-class',
  [FileAttachmentTagStatuses.organSpecimenPhoto]: 'on-scene-status-class',
  [FileAttachmentTagStatuses.flightCostCalculator]: 'wheels-up-air-status-class',
  [FileAttachmentTagStatuses.cateringReceipt]: 'picked-Up-class',
};

export const MaxMinutesUnderHour = 60;
